
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TopicLeaf } from '../../model/TopicLeaf';
import { CoursewareService } from '../../services/CoursewareService';
import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
import { AlertService } from 'src/app/_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';

@Component({
    selector: 'courseware',
    templateUrl: './courseware.component.html',
    styleUrls: ['./courseware.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class CoursewareComponent extends BaseComponent implements OnInit, OnDestroy {
    public courses: TopicLeaf[];
    public static cacheCourses: TopicLeaf[];
    public levelOneAlias: string;
    public levelTwoAlias: string;
    navigationSubscription;

    constructor(private canonicalService: MetaService, private titleService: Title, private route: ActivatedRoute, private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) {
        super();
        this.titleService.setTitle("Foundations of Law - LawShelf Educational Media");
        this.canonicalService.addMetaTags(null, "Foundations of Law - In-depth online summaries of major law topics", null, "Foundations of Law - LawShelf Educational Media", null);

        this.navigationSubscription = this._router.events.subscribe((e: any) => {
            if (e instanceof NavigationEnd) {
                this.clearAnswers();
            }
        });
    }

    clearAnswers() {
        this.levelOneAlias = this.route.snapshot.paramMap.get('levelonealias');
        this.levelTwoAlias = this.route.snapshot.paramMap.get('leveltwoalias');
        this.getCourses();
    }

    ngOnDestroy() {
        this.canonicalService.removeCanonicalURL();
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

    findTopicDetails() {
        if (this.levelOneAlias != "topic") {
            this.setCanonLink();
            return;
        }
        this.courses.forEach(parentTopic => {
            if (this.levelOneAlias != "topic") {
                this.setCanonLink();
                return;
            }
            let currentParentTopic = parentTopic.TopicInformation.Alias;
            if (parentTopic.TopicInformation.Alias == this.levelTwoAlias) {
                this.levelOneAlias = this.levelTwoAlias;
                this.levelTwoAlias = null;
                this.setCanonLink();
                return;
            }
            parentTopic.Children.forEach(childTopic => {
                if (childTopic.TopicInformation.Alias == this.levelTwoAlias) {
                    this.levelOneAlias = currentParentTopic;
                    this.setCanonLink();
                    return;
                }
            })
        });
    }

    setCanonLink() {
        if (!this.levelOneAlias && !this.levelTwoAlias)
            this.canonicalService.createCanonicalURL(this._router.url, "/coursewareview/");
        if (this.levelOneAlias && !this.levelTwoAlias)
            this.canonicalService.createCanonicalURL(this._router.url, "/coursewareview/" + this.levelOneAlias);
        if (this.levelOneAlias && this.levelTwoAlias)
            this.canonicalService.createCanonicalURL(this._router.url, "/coursewareview/" + this.levelOneAlias + "/" + this.levelTwoAlias);
    }

    ngOnInit() {
        let lastLevelOneAlias = this.levelOneAlias;
        let lastLevelTwoAlias = this.levelTwoAlias;
        this.levelOneAlias = this.route.snapshot.paramMap.get('levelonealias');
        this.levelTwoAlias = this.route.snapshot.paramMap.get('leveltwoalias');
        if (this.levelOneAlias != lastLevelOneAlias || this.levelTwoAlias != lastLevelTwoAlias)
            this.getCourses();
    }

    getCourses() {
        this.pushAllAds(2);
        if (!CoursewareComponent.cacheCourses) {
            this.coursewareService.getCourses().subscribe(data => {
                this.courses = CoursewareComponent.cacheCourses = data as TopicLeaf[];
                if (!this.courses.length && this.courses.length <= 0) {
                    let error: Error = data as Error;
                    this.alertService.error(error.Message);
                    return;
                }
                this.findTopicDetails();
            });
        }
        else {
            this.courses = CoursewareComponent.cacheCourses;
            this.findTopicDetails();
        }
    }

    onShowContentEntryClicked(theContentEntryClickedOn: ContentEntryDisplayData) {
        this._router.navigateByUrl("/coursewarecontentview/" + theContentEntryClickedOn.RenderData.ContentEntryDescriptor.Information.Alias);
        //this._router.navigate(["/coursewarecontentview", theContentEntryClickedOn.RenderData.ContentEntryDescriptor.Information.Alias]);
    }
}